import { Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import {
  getAllSupplier,
  getClinicFacilitiesWoLoader,
  getClinicStocksWoLoader,
  getDiagnosticTemplatesWoLoader,
  getInventoryDashboardData,
  getLocations,
} from "../../../redux/reducers/clinicSlice";
import { getClinicVetsWoLoader } from "../../../redux/reducers/vetSlice";
import { rolesToCreateInventory } from "../../../util/arrayList";
import ServiceCreateUpdate from "../../CommonScreens/Service/ServiceCreateUpdate";
import PurchaseInvoiceCreateView from "../../CommonScreens/Stock/PurchaseInvoiceCreateView";
import StockAdjustment from "../../CommonScreens/Stock/StockAdjustment";
import StockCreateUpdate from "../../CommonScreens/Stock/StockCreateUpdate";
import StockRequestModal from "../../CommonScreens/Stock/StockRequestModal";

const InventoryDashboard = ({ setActiveTab, setActiveSubTab }) => {
  const dispatch = useDispatch();
  const [stockCreateVsble, setStockCreateVsble] = useState(false);
  const [serviceCreateVsble, setServiceCreateVsble] = useState(false);
  const [adjustModVsble, setAdjustModVsble] = useState(false);
  const [purchaseInvoiceModVsble, setPurchaseInvoiceModVsle] = useState(false);
  const [transferModVsble, setTransferModVsble] = useState(false);
  const { inventoryDashboard: dashData, selectedClinicBranch } = useSelector(
    (state) => state?.clinic,
  );
  const role = localStorage.getItem("role");
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);

  useEffect(() => {
    onApiCall();
  }, []);

  const onApiCall = () => {
    dispatch(getInventoryDashboardData());
  };

  const onViewStock = () => {
    setActiveTab("Stock", "All Stock");
  };

  const onViewLowStock = () => {
    setActiveTab("Stock", "Low Stock");
  };

  const onViewNearExpiryStock = () => {
    setActiveTab("Stock", "Near Expiry");
  };

  const onViewPurchase = () => {
    setActiveTab("Purchase", "Purchase Orders");
  };

  const onViewRequest = () => {
    setActiveTab("Request & Transfer", null);
  };

  const onCloseStockMod = (typ) => {
    setStockCreateVsble(false);
    if (typ === "apiSuccess") onApiCall();
  };

  const onCloseServiceMod = (typ) => {
    setServiceCreateVsble(false);
    if (typ === "apiSuccess") onApiCall();
  };

  const getDiagnosticTemplates = () => {
    dispatch(getDiagnosticTemplatesWoLoader());
  };

  const onCreateService = () => {
    setServiceCreateVsble(true);
    getDiagnosticTemplates();
  };

  const onCloseAdjust = (typ) => {
    setAdjustModVsble(false);
    if (typ === "apiSuccess") onApiCall();
  };

  const onStockAdjust = () => {
    setAdjustModVsble(true);
    if (profile?.role === "ROLE_DOCTOR") {
      if (!selectedClinicBranch?.branchId) return;
      const reqUrl = `?clinicId=${selectedClinicBranch?.branchId}`;
      dispatch(getAllSupplier(reqUrl));
      dispatch(getLocations(reqUrl));
      return;
    }
    dispatch(getAllSupplier());
    dispatch(getLocations());
  };

  const onClosePurchaseInvoice = (typ) => {
    setPurchaseInvoiceModVsle(false);
    if (typ === "apiSuccess") onApiCall();
  };

  const onNewTransfer = () => {
    setTransferModVsble(true);
    dispatch(getClinicStocksWoLoader());
    dispatch(getClinicFacilitiesWoLoader());
    dispatch(getClinicVetsWoLoader("?type=all"));
    // if (role === "ROLE_CLINIC") {
    // dispatch(getClinicRoles());
    dispatch(getLocations());
    // }
  };

  const handleModClose = (typ) => {
    setTransferModVsble(false);
    if (typ === "apiSuccess") onApiCall();
  };

  return (
    <>
      <div className="ph40 scroll-90vh">
        <div className="flex-row-between mv10">
          <div className="w18Per">
            <div className="bil-dash-card bil-card-green">
              <div className="p15">
                <Typography className="fs12 font-bold gray-color">
                  {dashData?.skusInStock?.label ?? "SKUs in Stock"}
                </Typography>
                <Typography className="fs30 font-bold black">
                  {dashData?.skusInStock?.count ?? 0}
                </Typography>
                <Typography className="fs12 font-medium gray-color ml2">
                  {dashData?.skusInStock?.description ?? ""}
                </Typography>
                <div className="mv5">
                  <Divider />
                </div>
                <Typography
                  className="blue-color fs12 txt-semi-bold underline cursor mt10"
                  onClick={onViewStock}
                >
                  View Stock
                </Typography>
              </div>
            </div>
          </div>
          <div className="w18Per">
            <div className="bil-dash-card bil-card-red">
              <div className="p15">
                <Typography className="fs12 font-bold gray-color">
                  {dashData?.lowStock?.label ?? "Low Stock"}
                </Typography>
                <Typography className="fs30 font-bold black">
                  {dashData?.lowStock?.count ?? 0}
                </Typography>
                <Typography className="fs12 font-medium gray-color">
                  <Typography className="fs12 font-medium gray-color">
                    {`${dashData?.lowStock?.caution ?? 0} caution · ${dashData?.lowStock?.critical ?? 0} critical`}
                  </Typography>
                </Typography>
                <div className="mv5">
                  <Divider />
                </div>
                <Typography
                  className="blue-color fs12 txt-semi-bold underline cursor mt10"
                  onClick={onViewLowStock}
                >
                  View low stock
                </Typography>
              </div>
            </div>
          </div>
          <div className="w18Per">
            <div className="bil-dash-card bil-card-orange">
              <div className="p15">
                <Typography className="fs12 font-bold gray-color">
                  {dashData?.nearExpiry?.label ?? "Near Expiry"}
                </Typography>
                <Typography className="fs30 font-bold black">
                  {dashData?.nearExpiry?.count ?? 0}
                </Typography>
                <Typography className="fs12 font-medium gray-color">
                  {dashData?.nearExpiry?.description ?? ""}
                </Typography>
                <div className="mv5">
                  <Divider />
                </div>
                <Typography
                  className="blue-color fs12 txt-semi-bold underline cursor mt10"
                  onClick={onViewNearExpiryStock}
                >
                  View expiry
                </Typography>
              </div>
            </div>
          </div>
          <div className="w18Per">
            <div className="bil-dash-card bil-card-orange">
              <div className="p15">
                <Typography className="fs12 font-bold gray-color">
                  {dashData?.pendingRequests?.label ?? "Pending Requests"}
                </Typography>
                <Typography className="fs30 font-bold black">
                  {dashData?.pendingRequests?.count ?? 0}
                </Typography>
                <Typography className="fs12 font-medium gray-color">
                  {dashData?.pendingRequests?.description ?? ""}
                </Typography>
                <div className="mv5">
                  <Divider />
                </div>
                <Typography
                  className="blue-color fs12 txt-semi-bold underline cursor mt10"
                  onClick={onViewRequest}
                >
                  View requests
                </Typography>
              </div>
            </div>
          </div>
          <div className="w18Per">
            <div className="bil-dash-card bil-card-blue">
              <div className="p15">
                <Typography className="fs12 font-bold gray-color">
                  {dashData?.purchases?.label ?? "Purchases"}
                </Typography>
                <Typography className="fs30 font-bold black">
                  {dashData?.purchases?.count ?? 0}
                </Typography>
                <Typography className="fs12 font-medium gray-color">
                  {`${dashData?.purchases?.purchaseOrders ?? 0} POs · ${dashData?.purchases?.pendingCount ?? 0} pending to add`}
                </Typography>
                <div className="mv5">
                  <Divider />
                </div>
                <Typography
                  className="blue-color fs12 txt-semi-bold underline cursor mt10"
                  onClick={onViewPurchase}
                >
                  View purchases
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div className="mv20 flex-row-ali-cen">
          {rolesToCreateInventory.includes(profile?.role) ? (
            <>
              <div>
                <CustomButton
                  text="Create Stock"
                  smallBtn
                  onClick={() => setStockCreateVsble(true)}
                />
              </div>
              <div className="ml15">
                <CustomButton
                  text="Create Service"
                  smallBtn
                  onClick={onCreateService}
                />
              </div>
            </>
          ) : null}
          <div
            className={
              rolesToCreateInventory.includes(profile?.role) ? "ml15" : ""
            }
          >
            <CustomButton
              text="Upload Purchase Invoice"
              smallBtn
              onClick={() => setPurchaseInvoiceModVsle(true)}
            />
          </div>
          <div className="ml15">
            <CustomButton
              text="New Transfer"
              smallBtn
              onClick={onNewTransfer}
            />
          </div>
          <div className="ml15">
            <CustomButton
              text="Stock Adjustment"
              smallBtn
              onClick={onStockAdjust}
            />
          </div>
        </div>
      </div>

      {stockCreateVsble ? (
        <StockCreateUpdate
          modVsble={stockCreateVsble}
          onCloseMod={onCloseStockMod}
          selecetdStock={null}
        />
      ) : null}
      {serviceCreateVsble ? (
        <ServiceCreateUpdate
          modVsble={serviceCreateVsble}
          onCloseMod={onCloseServiceMod}
          selectedService={null}
        />
      ) : null}
      {adjustModVsble ? (
        <StockAdjustment modVsble={adjustModVsble} onCloseMod={onCloseAdjust} />
      ) : null}
      {transferModVsble ? (
        <StockRequestModal
          modVsble={transferModVsble}
          handleModClose={handleModClose}
          selectedItem={null}
        />
      ) : null}
      {purchaseInvoiceModVsble ? (
        <PurchaseInvoiceCreateView
          modVsble={purchaseInvoiceModVsble}
          onCloseMod={onClosePurchaseInvoice}
          type="Invoice"
          hideManualEntry
        />
      ) : null}
    </>
  );
};

export default InventoryDashboard;
